import React, { useEffect } from "react";
import img1 from "../../../assets/gps/mobile1.png";
import img2 from "../../../assets/gps/mobile2.png";
import img3 from "../../../assets/gps/mobile3.png";
import img4 from "../../../assets/gps/mobile4.png";
import img5 from "../../../assets/gps/mobile5.png";
import img6 from "../../../assets/gps/mobile6.png";
import AOS from "aos";
import "aos/dist/aos.css";
const mobileProducts = [
  {
    image: img1,
    content:
      "Live GPS tracking and driving history Shows accurate location of vehicle using its high quality GPS antenna. The device updates location every 10 seconds while in motion and keeps you connected in idle condition",
    aos: "fade-right",
  },
  {
    image: img2,
    content:
      "nstant Anti Theft Alarm Get notified in case of theft by alarm notification. (if ignition is turned on or vehicle is moved via towing or pushing)",
    aos: "fade-left",
  },
  {
    image: img3,
    content:
      "Remote Engine Lock Simply turn off your vehicle by swiping down in app. The vehicle will be turned off within seconds if driven in less than 10 km/hr or in idle state.",
    aos: "fade-right",
  },
  {
    image: img4,
    content:
      "Daily statistics All the daily stats like Run time, Idle time, Stoppage time, Distance, Average speed and Max speed are shown on daily basis.",
    aos: "fade-left",
  },
  {
    image: img5,
    content:
      "Safezone Use safezone feature to create safezone around your vehicle to get notified as soon as the vehicle enter/exit state in that region.",
    aos: "fade-right",
  },
  {
    image: img6,
    content:
      "Graphical Report Check 14 days graphical report of your vehicle in Analytics section by default and change the dates with calender option available on the top section.",
    aos: "fade-left",
  },
];
const GpsFeature = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 100,
      delay: 200,
    });
  }, []);
  return (
    <div className="mx-8 lg:mx-12">
      <div
        className="sm:py-10 py-5  flex justify-center items-center flex-col text-center"
        data-aos="zoom-in"
      >
        <h1 className="xl:text-5xl lg:text-3xl text-2xl font-bold tracking-wide text-black sm:pb-5 pb-3 pt-5">
          GPS Features
        </h1>
        <p className="sm:text-lg text-md font-normal xl:w-[62%] sm:w-[80%] mx-auto text-[#868686] tracking-wide">
          Our GPS technology offers real-time tracking, route optimization,
          geofencing, and location history. Stay connected, monitor movements,
          and enhance security with precision and reliability.
        </p>
      </div>
      <div className="grid sm:grid-cols-2 grid-cols-1 sm:py-10 py-5 gap-10 lg:px-10 px-5">
        {mobileProducts.map((product, index) => {
          return (
            <div
              className="flex xl:flex-row flex-col sm:pb-10 pb-5"
              data-aos={product.aos}
            >
              <img src={product.image} alt="mobile1" className="object-cover" />
              <p className="text-lg font-semibold xl:w-[33%] text-[#252525] tracking-wide pt-10 leading-normal xl:text-start text-center">
                {product.content}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GpsFeature;
